<template>
<div class="winner_center ">
    <indexTitle english_title="Winner" chinese_title="得獎名單"  page='true'></indexTitle>
    <router-view></router-view>
</div>
    
</template>
<script>
import IndexTitle from '@/components/index/IndexTitle'
export default {
    components: {
        'indexTitle': IndexTitle,
    },
}
</script>
<style>
</style>


